import { render, staticRenderFns } from "./index.vue?vue&type=template&id=83d7b13c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=83d7b13c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d7b13c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d7b13c')) {
      api.createRecord('83d7b13c', component.options)
    } else {
      api.reload('83d7b13c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=83d7b13c&scoped=true", function () {
      api.rerender('83d7b13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/tools/SendEmail/index.vue"
export default component.exports